import React, {useEffect} from 'react';
import {assert} from 'assert-ts';
import {useNavigate, useParams} from 'react-router';
import {useLocalization} from 'localization';
import {px2rem} from 'theme';
import {useGetWorkByEanQuery} from 'services/metadata';
import {ActivityIndicator, Card, Layout, Spacer, Text} from 'components';
import {ActionButtonV2} from 'components/button/ActionButtonV2';

export const EanToWorkRedirect = () => {
  const params = useParams();
  const navigate = useNavigate();
  const {t} = useLocalization();

  const ean = assert(
    params['ean'],
    'EanToWorkRedirect: ean parameter expected',
  );

  const {data, error} = useGetWorkByEanQuery(ean);

  useEffect(() => {
    if (data) {
      navigate(`/metadata/${data.work.id}?ean=${ean}`, {
        replace: true,
      });
    }
  }, [data, ean, navigate]);

  if (error) {
    return (
      <Layout adjustCenter paddingTop="20vh">
        <Layout sx={{maxWidth: px2rem(480)}}>
          <Card level="level3">
            <Layout p={2} adjustCenter>
              <Text variant="h3" kind="error">
                {t('error.failedtoLoadMetadata')}
              </Text>
              <Spacer size={4} />
              <Layout sx={{minWidth: px2rem(120)}}>
                <ActionButtonV2
                  title={t('error.retry')}
                  onClick={() =>
                    navigate(`${location.pathname}${location.search}`)
                  }
                />
              </Layout>
            </Layout>
          </Card>
        </Layout>
      </Layout>
    );
  }

  return (
    <Layout adjustCenter paddingTop="20vh">
      <ActivityIndicator />
    </Layout>
  );
};
